import styled from 'styled-components';
import Box from '@material-ui/core/Box';

const SPIREON_RED = '#b3282d';

export const LoginParentWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;
  position: relative;
  background: #fff;
`;

export const LeftPanel = styled.div`
  flex: 0 0 58.333333%;
  max-width: 58.333333%;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #fff;
  overflow-y: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    display: none;
  }
`;

export const RightPanel = styled.div`
  flex: 0 0 41.666667%;
  max-width: 41.666667%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: #fff;
  position: relative;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    flex: 1 1 100%;
    max-width: 100%;
    padding: 24px 24px 32px;
  }
`;

export const MarketingPageBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
`;

export const MarketingContainer = styled(Box)`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  padding: 0 14px;

  .marketing-spacer {
    height: 16px;
  }

  .marketing-heading {
    color: #102c52;
    font-family: Roboto, sans-serif !important;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: -0.02em;
    line-height: 1.1;
    margin-bottom: 15px !important;
    margin-top: 8px;
    padding: 0;
    text-align: center;
  }

  .marketing-description,
  .marketing-description.MuiTypography-body1 {
    color: #333 !important;
    display: flex !important;
    font-family: Roboto, sans-serif !important;
    font-size: 16px !important;
    font-weight: 400 !important;
    justify-content: space-around !important;
    letter-spacing: 0.0001em !important;
    line-height: 1.4 !important;
    margin-bottom: 24px;
    padding: 0;
    text-align: center !important;
    max-width: none;
  }
`;

export const MarketingImageWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;

  .marketing-card-image {
    display: block;
    width: 100%;
    max-width: 1024px;
    aspect-ratio: 1024 / 430;
    margin: 0 auto;
    object-fit: cover;
    object-position: center center;
  }
`;

export const MarketingButtonContainer = styled(Box)`
  margin-top: 50px;
  margin-bottom: 20px;
  text-align: center;

  .marketing-button {
    background-color: #102c52 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    color: #fff !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu,
      Cantarell, 'Helvetica Neue', sans-serif !important;
    font-size: 20px !important;
    font-weight: 400 !important;
    letter-spacing: 0.001em;
    line-height: 34px !important;
    margin-bottom: 20px;
    padding: 5px 20px !important;
    text-transform: none !important;
  }

  .marketing-button:hover {
    background-color: #0d2342 !important;
  }
`;

export const LoginMenuBar = styled.div`
  position: absolute;
  top: 16px;
  right: 24px;
  z-index: 10;
`;

export const LoginMenuTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;

  &:hover {
    background: #f5f5f5;
  }
`;

export const LoginMenuDropdown = styled.div`
  position: absolute;
  top: 44px;
  right: 0;
  min-width: 160px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  z-index: 20;
`;

export const LoginMenuItem = styled.button`
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 14px;
  color: #333;
  cursor: pointer;

  &:hover {
    background: #f0f2f2;
  }
`;

export const LoginWrapper = styled.div`
  width: 100%;
  max-width: 66.666667%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
  box-sizing: border-box;

  .formLogin {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  .formLogin form {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
`;

export const RightPanelContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
`;

export const RightPanelTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`;

export const RightPanelBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`;

export const LogoWrapper = styled.div`
  text-align: center;
  /* margin-bottom: 32px; */

  img {
    max-width: 310px;
    height: auto;
  }
`;

export const LoginError = styled.div`
  margin-bottom: 12px;
`;

export const LoginForm = styled.div`
  width: 310px;
  margin-bottom: 8px;

  .MuiFormControl-root {
    margin-top: 16px;
    margin-bottom: 8px;
  }

  .MuiInput-root::before {
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  }

  .MuiInput-root:hover:not(.Mui-disabled)::before {
    border-bottom: 2px solid rgba(0, 0, 0, 0.87);
  }

  .MuiInput-root::after {
    border-bottom: 2px solid ${SPIREON_RED};
  }

  .MuiInputBase-input {
    padding: 6px 0 7px;
    background: transparent !important;
  }

  .MuiInputLabel-root {
    font-size: 1rem;
  }

  .remember-forgot-row {
    margin: 0 0 24px 0;
  }

  .remember-forgot-row .MuiFormControlLabel-root {
    margin: 0;
  }

  .remember-forgot-row .MuiFormControlLabel-label {
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    margin: 0 0 0 8px;
    color: rgba(0, 0, 0, 0.87);
  }

  .remember-forgot-row .remember-me-checkbox {
    padding: 9px;
    width: 16px;
    color: rgba(0, 0, 0, 0.54);
  }

  .remember-forgot-row .remember-me-checkbox-icon {
    font-size: 16px !important;
    width: 16px;
    height: 16px;
  }

  .remember-forgot-row .remember-me-checkbox.Mui-checked,
  .remember-forgot-row .remember-me-checkbox-icon--checked {
    color: #343e48 !important;
  }

  .remember-forgot-row .remember-me-checkbox.Mui-checked .remember-me-checkbox-icon {
    color: #343e48 !important;
    fill: currentColor;
  }

  .forgot-password-cell {
    text-align: right;
  }

  .forgot-password-link {
    color: ${SPIREON_RED} !important;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.001em;
    text-decoration: none;
  }

  .sign-in-button {
    height: 48px;
    background-color: ${SPIREON_RED} !important;
    text-transform: none;
    font-size: 24px !important;
    font-weight: 500;
  }

  .sign-in-button:hover {
    background-color: #a81c00 !important;
  }
`;

export const AppStoreRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 310px;
  margin-top: 30px;

  a img {
    height: 45px;
    width: 153px;
    display: block;
  }
`;

export const LoginFooter = styled.div`
  text-align: center;
  font-size: 14px;
  color: #000000de;
  line-height: 1.6;
  width: 100%;
  max-width: 380px;

  p {
    margin: 0 0;
  }

  a {
    color: ${SPIREON_RED};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  .access-code-prompt {
    margin-top: 12px;
  }

  .access-code-link {
    margin-bottom: 16px;
  }

  .footer-legal-link {
    display: block;
    text-decoration: underline;
    margin-top: 8px;
    font-size: 14px;
  }

  .copyright {
    margin-top: 16px;
    font-size: 12px;
    color: #888;
  }

  .footer-legal-links {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
`;

const Styled = {
  LoginParentWrapper,
  LeftPanel,
  RightPanel,
  MarketingPageBox,
  MarketingContainer,
  MarketingImageWrapper,
  MarketingButtonContainer,
  LoginMenuBar,
  LoginMenuTrigger,
  LoginMenuDropdown,
  LoginMenuItem,
  LoginWrapper,
  RightPanelContent,
  RightPanelTop,
  RightPanelBottom,
  LogoWrapper,
  LoginError,
  LoginForm,
  AppStoreRow,
  LoginFooter,
};

export default Styled;
